import { render } from "./Endereco.vue?vue&type=template&id=a8da06dc&scoped=true"
import script from "./Endereco.vue?vue&type=script&lang=js"
export * from "./Endereco.vue?vue&type=script&lang=js"

import "./Endereco.vue?vue&type=style&index=0&id=a8da06dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8da06dc"]])

export default __exports__